import { memo } from 'react';
import { hiddenHeaderStyle } from '../../assets/styles/StationDataTable.styles';

interface PrecipitationHeaderProps {
  text: string;
}

const PrecipitationHeader = memo(({ text }: PrecipitationHeaderProps) => (
  <div style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
    <div style={hiddenHeaderStyle}>xxx</div>
    <div style={{ position: 'relative', backgroundColor: '#ffffff', textAlign: 'center' }}>{text}</div>
  </div>
), (prevProps, nextProps) => prevProps.text === nextProps.text);

export default PrecipitationHeader;
